import SdekMap from "./SdekMap";

export default SdekMap;
